var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.649,
    height: 20.649,
    viewBox: "0 0 20.649 20.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6100",
    "data-name": "Group 6100",
    transform: "translate(1253.695 7067.809)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 9.825,
    cy: 9.825,
    r: 9.825,
    transform: "translate(-1253.195 -7067.309)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6099",
    "data-name": "Group 6099"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6217",
    "data-name": "Line 6217",
    y2: 8.32,
    transform: "translate(-1243.37 -7061.644)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6218",
    "data-name": "Line 6218",
    x1: 8.32,
    transform: "translate(-1247.531 -7057.484)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.a2c99aa200cf1da35959501fdeae4cb2.svg";
export { ForwardRef as ReactComponent };